export enum TypeRegister {
  Unavailable = 'IRREPER',
  DeleteAire = 'CAIRE',
  Citizenship = 'CITTAD',
  SubscriptionAire = 'IAIRE',
  RegisterOfficeTemporary = 'TEMRES',
  RenewalResidence = 'RINDIM',
  SpinOffAggregation = 'SCIAGG',
  Immigration = 'IMMIGR',
  Emigration = 'EMIGR',
  Residence = 'RESID',
  RegistryChanges = 'APRVAR',
  PopularJudges = 'ELEGPOP',
  Electoral = 'ELETT',
  UntraceableCensus = 'IRRCEN',
  CriminalRecord = 'PROTPEN',
  DifferentCommunication = 'COMUNICA',
  AuthorizationToVoteOutsideTheMun = 'ELAEX',
  AuthorizationToVotePlacesOfCare = 'ELEAUT',
  AddressChange = 'VARINT',
}
